import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance, ensureMsalInitialized } from '@/lib/auth/msalConfig';
import { wireV2ClientTokenGetter } from '@/lib/auth/tokenGetter';
import { capturePostLoginReturnTo } from '@/lib/auth/returnTo';
import App from '@/App';
import '@/index.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

ensureMsalInitialized()
  .then(async () => {
    // T-17 (T17-D13) — finish the redirect handshake and park a deep link's
    // return path for LoginPage. A failure here must not block the app.
    try {
      await capturePostLoginReturnTo(msalInstance);
    } catch (err) {
      console.error('post-login return-path capture failed', err);
    }
    wireV2ClientTokenGetter();
    createRoot(rootEl).render(
      <StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </StrictMode>,
    );
  })
  .catch((err) => {
    console.error('MSAL init failed', err);
    rootEl.textContent = 'Failed to initialize sign-in. Please refresh.';
  });
